import React, { useState } from 'react';
import './style.scss';

export const RoundButton = (props) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  return (
    <div className={'round-button-container'}>
      {props.tooltip && <div className={`tooltip ${isTooltipVisible ? 'show' : ''}`}>{props.tooltip}</div>}
      <button
        {...props}
        onClick={(e) => {
          props.onClick(e);
          props.tooltip && setIsTooltipVisible(true);
          props.tooltip && setTimeout(setIsTooltipVisible.bind(false), 800);
        }}>
        <img src={props.icon} className='icon' />
      </button>
    </div>
  );
};
